import PgSignIn from "./PgSignIn";
const AuthPages = {
    PgSignIn
};

export default AuthPages;